import * as THREE from 'three';
import { ROSELoader } from './rose';

export class SkeletonBone {
  parent: number = 0;
  name: string = '';
  position: any = null;
  rotation: any = null;
}

/**
 * @property {SkeletonBone[]} bones
 * @property {SkeletonBone[]} dummies
 */
export class SkeletonData {
  // Static reference to nested class for backwards compatibility
  static Bone = SkeletonBone;

  bones: SkeletonBone[] = [];
  dummies: SkeletonBone[] = [];

  create(rootObj: any): any {
    const parts: any[] = [];
    let bones: any[] = [];
    let dummies: any[] = [];

    const fakeRoot = new THREE.Object3D();

    for (let i = 0; i < this.bones.length; ++i) {
      const b = this.bones[i];

      const boneX = new (THREE.Bone as any)(rootObj);
      boneX.name = b.name;
      boneX.position.copy(b.position);
      boneX.quaternion.copy(b.rotation);
      boneX.scale.set(1, 1, 1);

      if (b.parent == -1) {
        fakeRoot.add(boneX);
      } else {
        bones[b.parent].add(boneX);
      }

      bones.push(boneX);
      parts.push(boneX);
    }

    for (let j = 0; j < this.dummies.length; ++j) {
      const d = this.dummies[j];

      const dummyX = new THREE.Object3D();
      dummyX.name = d.name;
      dummyX.position.copy(d.position);
      dummyX.quaternion.copy(d.rotation);
      dummyX.scale.set(1,1,1);

      parts[d.parent].add(dummyX);

      dummies.push(dummyX);
      parts.push(dummyX);
    }

    const skel = new THREE.Skeleton(bones);
    (skel as any).dummies = dummies;

    fakeRoot.updateMatrixWorld();
    skel.calculateInverses();

    fakeRoot.remove(bones[0]);
    rootObj.add(bones[0]);

    return skel;
  }

  static load(path: any, callback: any) {
    ROSELoader.load(path, function(rh: any) {
      let bones: any, dummies: any, i: any, magic: any, version: any;
      const data = new SkeletonData();

      magic = rh.readStrLen(7);
      if (magic === 'ZMD0002') {
        version = 2;
      } else if (magic === 'ZMD0003') {
        version = 3;
      } else {
        throw 'Unexpected ZMD magic header ' + magic + ' in ' + path;
      }

      bones = rh.readUint32();
      for (i = 0; i < bones; ++i) {
        const bone = new SkeletonBone();
        bone.parent   = rh.readUint32();
        bone.name     = rh.readStr();
        bone.position = rh.readVector3().multiplyScalar(ZZ_SCALE_IN);
        bone.rotation = rh.readQuatwxyz();

        if (i == 0) {
          bone.parent = -1;
        }

        data.bones.push(bone);
      }

      dummies = rh.readUint32();
      for (i = 0; i < dummies; ++i) {
        const dummy = new SkeletonBone();
        dummy.name     = rh.readStr();
        dummy.parent   = rh.readUint32();
        dummy.position = rh.readVector3().multiplyScalar(ZZ_SCALE_IN);

        if (version === 3) {
          dummy.rotation = rh.readQuatwxyz();
        } else {
          dummy.rotation = new THREE.Quaternion(0,0,0,1);
        }

        data.dummies.push(dummy);
      }

      callback(data);
    });
  }
}
